import React from 'react';
import { graphql, withApollo } from 'react-apollo';

import {
  Input,
  Button,
  Modal,
  Col,
  Row,
  DatePicker,
  notification,
} from 'antd/lib';
import moment from 'moment';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import Loading from '../../common/Loading';

const { TextArea } = Input;
const confirm = Modal.confirm;

import getCertificacionTraspasoPorId from '../../../graphql/querys/rrhh/getCertificacionTraspasoPorId.graphql';
import procesarCertificacionTraspaso from '../../../graphql/mutations/rrhh/procesarCertificacionTraspaso.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

@graphql(getUsuario)
@graphql(procesarCertificacionTraspaso, {
  name: 'procesarCertificacionTraspaso',
})
class ProcesarCertificacionTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      certificacion: {},
      fecha: moment(),
      observacion: '',
    };

    this.props.client
      .query({
        query: getCertificacionTraspasoPorId,
        variables: {
          _id: this.props.match.params.id,
        },
      })
      .then(res => {
        let certificacion = res.data.getCertificacionTraspasoPorId;
        // console.log('CERT llega =>', certificacion);
        if (certificacion) {
          this.setState({
            ...this.state,
            loading: false,
            certificacion,
          });
        }
      })
      .catch(err => {
        console.log('Error en la busqueda de la certificacion');
        console.log(err);

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  handleSubmit = e => {
    e.preventDefault();
    let yo = this;
    confirm({
      title: '¿Realmente quiere procesar y guardar?',
      content: `Al presionar aceptar, la certificación pasará a estado procesada.`,
      onOk() {
        // si confirma llamo  a la funcion que se encarga de visar la certificacion
        yo.procesarCertificacionTraspaso();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  procesarCertificacionTraspaso = () => {
    this.setState({
      ...this.state,
      loading: true,
    });

    this.props
      .procesarCertificacionTraspaso({
        variables: {
          _id: this.state.certificacion._id,
          fechaProcesado: this.state.fecha,
          observacionProcesado: this.state.observacion,
        },
      })
      .then(res => {
        // console.log('res visar', res);
        this.setState(
          {
            ...this.state,
            loading: false,
          },
          () => this.props.history.push('/rrhh/certificacionesTraspaso')
        );

        notification.success({
          message: 'Certificacion Procesada con exito',
          description: 'Se ha registrado los nuevos datos de la certificacion.',
        });
      })
      .catch(err => {
        console.log('Error al procesar la certificacion');
        console.log(err);

        Modal.error({
          title: 'Error al procesar de la certificacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <h2 style={{ textAlign: 'center', marginTop: 20, marginBottom: 100 }}>
          Procesado Certificacion Traspaso
        </h2>
        <Form encType="multipart/form-data" onSubmit={this.handleSubmit}>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Fecha: </h3>
                <DatePicker
                  showTime={{
                    minuteStep: 10,
                    format: 'HH:mm',
                  }}
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Seleccionar Fecha y Hora"
                  style={{ color: '#000000', width: 270 }}
                  defaultValue={this.state.fecha}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Observacion: </h3>
                <TextArea
                  required
                  rows={5}
                  id="observacionProcesado"
                  value={this.state.observacion}
                  placeholder="Complete con sus observaciones"
                  onChange={e =>
                    this.setState({
                      ...this.state,
                      observacion: e.target.value,
                    })
                  }
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 50, marginBottom: 20 }}>
            <Col style={{ margin: 'auto' }}>
              <Button type="primary" htmlType="submit">
                Guardar
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                type="danger"
                onClick={() =>
                  this.props.history.push('/rrhh/certificacionesTraspaso')
                }
              >
                Atras
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default withApollo(ProcesarCertificacionTraspaso);
